// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const bounsweet: PokeData = {
  "id": 761,
  "name": "bounsweet",
  "height": 3,
  "weight": 32,
  "base_experience": 42,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "razor-leaf",
    "splash",
    "flail",
    "rapid-spin",
    "sweet-scent",
    "teeter-dance",
    "aromatherapy",
    "magical-leaf",
    "play-nice",
    "aromatic-mist"
  ],
  "moves": [
    "razor-leaf",
    "splash",
    "aromatherapy",
    "flower-rush",
    "leaf-tornado",
    "branch-poke",
    "frenzy-plant",
    "overgrowth",
    "bullet-seed",
    "grassy-terrain",
    "power-whip",
    "solar-beam",
    "energy-ball"
  ],
  "evolution_chain": {
    "id": 392,
    "item": null,
    "species": [
      {
        "name": "bounsweet",
        "order": 761,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "steenee",
        "order": 762,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 761,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "tsareena",
        "order": 763,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 762,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "stomp"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 40,
    "speed": 32,
    "ability_power": 30
  },
  "stat_changes": [],
  "catch_rate": 235,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
